import React from "react";

function Copyright() {
  return (
    <section className="flex items-center justify-center text-center w-full h-[76px] bg-third">
      <p className="">Copyright © Dinkominfo Kabupaten Banyumas</p>
    </section>
  );
}

export default Copyright;
